export const env = {
  DEV: process.env.MODE !== "production",
  PROD: process.env.MODE === "production",
  MODE: process.env.MODE,
  BASE_URL: process.env.BASE_URL,
  GRAPH_EXP_FEEDBACK_URL: process.env.GRAPH_EXP_FEEDBACK_URL,
};

const _base = (process.env.PUBLIC_URL ?? "").replace(/\/+$/, "");

export function appHref(path: string): string {
  if (!path.startsWith("/")) return path;
  return `${_base}${path}`;
}

export function stripBase(path: string): string {
  if (_base && path.startsWith(_base)) {
    return path.slice(_base.length) || "/";
  }
  return path;
}
